import { getImageReference } from "@tiicker/util/lib/contentful/helpers";
import { ContentSection } from "@tiicker/util/lib/contentful/types";
import Markdown from "components/Markdown/Markdown";
import { Entry } from "contentful";
import styles from "./PartnerWithUsStatsSection.module.scss";
import React, { forwardRef } from "react";

interface Props {
  title: string|undefined;
  contentSections: Entry<ContentSection>[];
  includes: any;
}

const PartnerWithUsStatsSection = forwardRef((props: Props, ref: React.Ref<HTMLDivElement>) => {
  return (
    <div ref={ref}>
      <h4 className={styles.PartnerWithUsStatsSection__title}>{props.title}</h4>
      <div className={styles.PartnerWithUsStatsSection__container}>
        {props.contentSections.map((section) => {
          const image = getImageReference(section.fields.image, props.includes);
          return (
            <div
              className={styles.PartnerWithUsStatsSection__item}
              key={section.sys.id}>
              {image && (
                <img
                  src={image.fields.file.url}
                  alt={image.fields.description}
                  className={styles.PartnerWithUsStatsSection__icon}
                />
              )}
              <Markdown
                markdownText={section.fields.textContent}
                className={styles.PartnerWithUsStatsSection__text}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
});

export default PartnerWithUsStatsSection;
